import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ece4a2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "index" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_3 = { style: {"line-height":"35px","margin":"10px 0"} }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "test" }, null, -1))
const _hoisted_6 = { class: "circle-cont" }
const _hoisted_7 = { class: "circle" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle-desc" }, "待匹配", -1))
const _hoisted_9 = { class: "circle-box" }
const _hoisted_10 = {
  class: "circle",
  style: {"background":"#f56c6c"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle-desc" }, "未处理", -1))
const _hoisted_12 = { class: "circle-box" }
const _hoisted_13 = {
  class: "circle",
  style: {"background":"#e6a23c"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle-desc" }, "待结算", -1))
const _hoisted_15 = { class: "date-picker" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 搜索 ")
const _hoisted_17 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tag, { type: "success" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.titleOne)
        ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 0,
            title: '订单未匹配：' + _ctx.titleOne,
            type: "warning",
            style: {"margin-bottom":"10px","padding-right":"25px"},
            closable: false
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      (_ctx.titleTwo)
        ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 1,
            title: '未上课：' + _ctx.titleTwo,
            type: "warning",
            style: {"margin-bottom":"10px","padding-right":"25px"},
            closable: false
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      (_ctx.titleThree)
        ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 2,
            title: '研究生未评价：' + _ctx.titleThree,
            type: "warning",
            style: {"margin-bottom":"10px","padding-right":"25px"},
            closable: false
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      (_ctx.titleFour)
        ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 3,
            title: '学生未评价：' + _ctx.titleFour,
            type: "warning",
            style: {"margin-bottom":"10px","padding-right":"25px"},
            closable: false
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      (_ctx.titleFive)
        ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 4,
            title: '教务未回访：' + _ctx.titleFive,
            type: "warning",
            style: {"margin-bottom":"10px","padding-right":"25px"},
            closable: false
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      (_ctx.titleSix)
        ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 5,
            title: '顾问未回访：' + _ctx.titleSix,
            type: "warning",
            style: {"margin-bottom":"10px","padding-right":"25px"},
            closable: false
          }, null, 8, ["title"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "circle-box",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.goOrder && $setup.goOrder(...args)))
        }, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.statusNum.waitMatch || 0) + "人", 1),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.statusNum.unHandle || 0) + "人 ", 1),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.statusNum.waitSettle || 0) + "人 ", 1),
          _hoisted_14
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.date,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date) = $event)),
          type: "daterange",
          "range-separator": "至",
          "start-placeholder": "开始时间",
          "end-placeholder": "截止时间",
          onChange: $setup.search2
        }, null, 8, ["modelValue", "onChange"]),
        _createVNode(_component_el_button, {
          class: "date-btn",
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.search()))
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _ctx.tableData,
          border: "",
          style: {"width":"800px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "jName",
              label: "教务",
              width: "200"
            }),
            _createVNode(_component_el_table_column, {
              prop: "total",
              label: "总匹配单量",
              width: "200"
            }),
            _createVNode(_component_el_table_column, {
              prop: "wait",
              label: "待匹配单量",
              width: "200"
            }),
            _createVNode(_component_el_table_column, {
              prop: "avageTime",
              label: "平均匹配时长",
              width: "200"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.avageTime || 0), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _ctx.tableLoading]
        ])
      ])
    ])
  ]))
}